import customFetch from "@utils/customFetch";
import { logger } from "@utils/log";
import * as History from "history";

import { AUDIT_API_URL } from "../constants";
import { QueryParam } from "../enums";
import { TRecordString } from "../global.types";
import { IHistoryState } from "../model/Model";

interface IGetQueryParameters {
    exclude?: QueryParam[];
    historyLocation?: History.Location;
}

export const getQueryParameters = (args: IGetQueryParameters = {}): Record<QueryParam, string> => {
    const search = new URLSearchParams(args.historyLocation?.search ?? window.location.search);
    if (args.exclude?.length) {
        for (const e of args.exclude) {
            search.delete(e);
        }
    }
    return Object.fromEntries(
        search
    ) as Record<QueryParam, string>;
};

export const removeQueryParam = (history: History.History<IHistoryState>, param: QueryParam, replaceState?: boolean): void => {
    const search = history.location.search;
    const params = new URLSearchParams(search);
    params.delete(param);

    const historyFn = replaceState ? history.replace : history.push;

    historyFn({
        pathname: history.location.pathname,
        search: params.toString()
    });
};

interface ISetQueryParams {
    history: History.History<IHistoryState>;
    newParams: TRecordString;
    replaceState?: boolean;
}

export const setQueryParams = (args: ISetQueryParams): void => {
    const search = args.history.location.search;
    const params = new URLSearchParams(search);
    for (const [key, val] of Object.entries(args.newParams)) {
        params.set(key, val);
    }

    const historyFn = args.replaceState ? args.history.replace : args.history.push;

    historyFn({
        pathname: args.history.location.pathname,
        search: params.toString()
    });
};

export const getRedirectUriQueryParam = (): string => {
    const { pathname, search } = window.location;
    if (!pathname || pathname === "/") {
        return "";
    }
    return `${QueryParam.RedirectUri}=${encodeURIComponent(pathname + (search ?? ""))}`;
};

export async function hasEntityExisted(entityTypeName: string, entityId: string): Promise<boolean> {
    try {
        const res = await customFetch(`${AUDIT_API_URL}/${entityTypeName}/${entityId}/exists`);
        const data = await res.text();
        return data?.toLowerCase() === "true";
    } catch (error) {
        logger.error("Error checking entity existence:", error);
    }
    return false;
}